import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const adminToken = localStorage.getItem('adminToken');
  // Most admin-only endpoints (e.g. POST /gallery, /cows, /faqs) don't have
  // "/admin" in their URL at all — they're only reachable from admin screens,
  // which always render under the /admin/* route. Use the current page,
  // not the request URL, to decide which token to attach.
  const isAdminContext = window.location.pathname.startsWith('/admin');
  const t = isAdminContext ? adminToken : token;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// If an admin token is missing/expired/invalid, the backend rejects with 401.
// The route guard only checks for the token's presence on initial load, so a
// token that goes stale mid-session (expiry, revocation) needs to be caught
// here and bounced back to the admin login instead of leaving a broken
// admin screen up.
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAdminContext = window.location.pathname.startsWith('/admin');
    if (isAdminContext && error.response?.status === 401 && window.location.pathname !== '/admin/login') {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default API;
